import { Assignment } from "@/types/models/Assignment.interface";

const ASSIGNMENT_MODE = {
  CREATE: "Create",
  UPDATE: "Update",
};

const currentAssignmentMode = (
  assignment: Pick<Assignment, "is_draft"> | undefined,
) => {
  if (
    !assignment ||
    assignment?.is_draft === undefined ||
    assignment?.is_draft
  ) {
    return ASSIGNMENT_MODE.CREATE;
  }
  return ASSIGNMENT_MODE.UPDATE;
};

export type TAssignmentMode = keyof typeof ASSIGNMENT_MODE;
export { ASSIGNMENT_MODE, currentAssignmentMode };
